import { CombinedManualAdjustmentType } from '@aloft/toolkit-shared';

export const ADJUSTMENT_LABELS: Record<CombinedManualAdjustmentType, string> = {
  adu: 'ADU',
  attic: 'Attic',
  barn: 'Barn',
  basement: 'Basement',
  basementTotal: 'Basement (Total)',
  basementFinished: 'Basement (Finished)',
  bathAboveGrade: 'Baths',
  bathBelowGrade: 'Baths (Below Grade)',
  bedrooms: 'Bedrooms',
  belowGradeANSI: 'Below Grade (per ANSI)',
  bonusRoom: 'Bonus Room',
  concessions: 'Financial Concessions',
  condition: 'Condition',
  dateOfSale: 'Date of Sale',
  externalObsolescence: 'External Obsolescence',
  fireplace: 'Fireplace',
  foundation: 'Foundation',
  functionalUtility: 'Functional Utility',
  garageCarport: 'Garage / Carport',
  gla: 'GLA (Use this one if you are using the new Adjustment Grid)',
  locationView: 'Location and View',
  mainDwelling: 'GLA',
  manual: 'Manual Cost',
  manufactured: 'Mfd. Dwelling',
  pool: 'Pool',
  poolSpa: 'Pool/Spa',
  porchPatioDeck: 'Porch/Patio/Deck',
  quality: 'Quality',
  shed: 'Shed',
  site: 'Site size, Location & View',
  siteInfluence: 'Site Influence',
  siteView: 'View',
  solarPanel: 'Solar Panel',
  termsOfSale: 'Terms of Sale',
  totalCostToCure: 'Total Cost to Cure',
  units: 'Number of Units',
  workshop: 'Workshop',
  other: 'Other',
  halfBaths: 'Half Baths',
  fullBaths: 'Full Baths',
  basementFullBaths: 'Basement Baths (Full)',
  basementHalfBaths: 'Basement Baths (Half)',
  aduFullBaths: 'ADU Baths (Full)',
  aduHalfBaths: 'ADU Baths (Half)',
  actualAge: 'Actual Age',
};
